import { z } from 'zod';

import type { TaleContent } from '@/components/Taleforge/types';

import TaleforgeIntroTale from './index.tale.mdx';

const tale: TaleContent = {
  taleComponent: () => <TaleforgeIntroTale />,
  defaultValues: {},
  schema: z.object({}),
};

export default tale;
